import { Location } from 'history';
import { z } from 'zod';
import { engineFieldDetailPath } from '../paths';

const engineFieldTypeSchema = z.enum(['tabular', 'header']);

export type EngineFieldType = z.TypeOf<typeof engineFieldTypeSchema>;

export const getAddNewFieldPath = (engineId: number, type: EngineFieldType) =>
  `${engineFieldDetailPath(engineId, 'new')}?type=${type}`;

export const getFieldTypeFromPath = (location: Location<unknown>) => {
  const searchParams = new URLSearchParams(location.search);
  const parsed = engineFieldTypeSchema.safeParse(searchParams.get('type'));

  if (parsed.success) return parsed.data;

  return 'header';
};
